import React, { createContext } from 'react';
import API_SPORDLE from '../api/API-Spordle';
import { serverError } from '../api/CancellableAPI';
import queryString from 'query-string';
import { OrganizationContext } from './OrganizationContext';
import withContexts from '../helpers/withContexts';

/** @type {React.Context<Omit<PhoneTypesContextProvider, keyof React.ComponentLifecycle<*, *> | 'render' | 'setState'>>} */
export const PhoneTypesContext = createContext();
PhoneTypesContext.displayName = 'PhoneTypesContext';

class PhoneTypesContextProvider extends React.Component{


    /**
     * GET[ALL] - Get phone types
     * @param {object} [queryParams] The query params for that call
     * @see Refer to the {@link https://api.id.spordle.dev/documentations/#/Phone%20Types/Apicontroller%5COrganisations%5CPhonetypes%3A%3Aindex|documentation}
     * @returns {Promise.<Array>}
     */
    getPhoneTypes = (queryParams = {}) => {
        return API_SPORDLE.get(queryString.stringifyUrl({
            url: `phone-types`,
            query: Object.assign({
                organisation_id: this.props.OrganizationContext.organisation_id,
            }, queryParams),
        }))
            .then((response) => {
                if(response.data.status){
                    return response.data.phone_types
                }
                throw response.data.errors[0]
            }, serverError)
    }

    /**
     * GET Specific phone type
     * @param {string} phone_type_id
     * @see Refer to the {@link https://api.id.spordle.dev/documentations/#/Phone%20Types/Apicontroller%5COrganisations%5CPhonetypes%3A%3AgetPhonetypeDetail|documentation}
     * @returns {Promise.<Array>}
     */
    getPhoneType = (phone_type_id) => {
        return API_SPORDLE.get(queryString.stringifyUrl({
            url: `phone-types/${phone_type_id}`,
        }))
            .then((response) => {
                if(response.data.status){
                    return response.data.phone_types[0]
                }
                throw response.data.errors[0]
            }, serverError)
    }

    render(){
        return (
            <PhoneTypesContext.Provider value={{ ...this }}>
                {this.props.children}
            </PhoneTypesContext.Provider>
        )
    }
}


export default withContexts(OrganizationContext)(PhoneTypesContextProvider);

